import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';

type Props = {
  invisible?: boolean;
  required?: boolean;
};

export function TitleInput({ invisible, required }: Props) {
  const { control } = useFormContext<{ title: string }>();
  return (
    <FormRow>
      <FormLabel>Название</FormLabel>
      <FormInput>
        <Controller
          name="title"
          control={control}
          rules={{
            required,
          }}
          render={({ field: { value, onChange, disabled } }) => (
            <Input invisible={invisible} value={value as string} onChange={onChange} disabled={disabled} />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
